import { render, staticRenderFns } from "./CustomFieldHeader.vue?vue&type=template&id=4ee72c3c"
import script from "./CustomFieldHeader.vue?vue&type=script&lang=js"
export * from "./CustomFieldHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports